module.exports = __webpack_public_path__ + "media/images/company-logos/schweizerische-gesellschaft-logo-8d7ada459b349c8b73c554d13fa63391.jpg";